import React, { useEffect, useContext, useState } from 'react';
import { SocketContext } from '../components/SocketContext';
import Button from '@mui/material/Button';
import { Stack, Paper } from '@mui/material';
import { styled } from '@mui/system';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    padding: theme.spacing(1),
    textAlign: 'center',
    color: '#FF0000',
}));

const WordSelector = () => {
    const socket = useContext(SocketContext);
    const [wordList, setWordList] = useState([]);

    useEffect(() => {
        socket.on('selectwords', (data) => {
            setWordList(data.words);
        });

        socket.on('toolate', (data) => {
            console.log("Too late to select a word");
            setWordList([]);
        });

        return () => {
            socket.off('selectwords');
            socket.off('toolate');
        };
    }, [socket, wordList]);

    let buttonclick = (word) => {
        console.log("Button clicked " + word);
        socket.emit('wordselected', { word: word });
        setWordList([]);
    }

    return (
        wordList.length > 0 &&
        <div>
            <h3>Select a word:</h3>
            <Stack direction="row" spacing={2}>
                {wordList.map((word, index) => (
                    <Button style={{ 'backgroundColor': 'rgba(255,255,255,0.75)' }} onClick={() => buttonclick(word)} key={word} variant="outlined">{word}</Button>
                ))}
            </Stack>
        </div>
    );
};

export default WordSelector;